'use client';

import { c as _c } from "react/compiler-runtime";
import { ReceiverTypes } from 'api-graphql-types/enums';
import { Checkbox } from 'design-system/client';
import { useParams } from 'next/navigation';
import { useTranslations, useLocale } from 'next-intl';
import { forwardRef } from 'react';
import styles from './PlatformNewsletterCheckbox.module.css';
import { NewsletterCheckboxProps } from './types';
import TextLink from '@/components/TextLink';
import DonationFormField from '@/donationPages/_dependencies/components/DonationFormField';
import { useDonationFormConfig } from '@/donationPages/_dependencies/helpers';
import { Routes } from '@/helpers/utils';
const NewsletterCheckbox = forwardRef<HTMLInputElement, NewsletterCheckboxProps>(function NewsletterCheckBox(t0, ref) {
  const $ = _c(26);
  let openModal;
  let props;
  if ($[0] !== t0) {
    ({
      openModal,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = openModal;
    $[2] = props;
  } else {
    openModal = $[1];
    props = $[2];
  }
  const t = useTranslations("nextjs.core.newsletter_consent.platform");
  const locale = useLocale();
  const {
    channel,
    receiverType: receiverType_
  } = useDonationFormConfig();
  const receiverType = receiverType_ === ReceiverTypes.Project ? "projects" : "fundraising-events";
  const {
    slug
  } = useParams();
  let t1;
  if ($[3] !== t) {
    t1 = t("label_prefix.donation_form");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== channel || $[6] !== locale || $[7] !== receiverType || $[8] !== slug) {
    t2 = Routes.donateDataProcessing({
      locale,
      channel,
      slug,
      "receiver-type": receiverType
    });
    $[5] = channel;
    $[6] = locale;
    $[7] = receiverType;
    $[8] = slug;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t) {
    t3 = t("consent_modal_opener_label");
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== openModal || $[13] !== t2 || $[14] !== t3) {
    t4 = <TextLink href={t2} onClick={openModal} kind="default" scroll={false}>{t3}</TextLink>;
    $[12] = openModal;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t) {
    t5 = t("label_suffix");
    $[16] = t;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t1 || $[19] !== t4 || $[20] !== t5) {
    t6 = <div>{t1}{" "}{t4}{" "}{t5}</div>;
    $[18] = t1;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== props || $[23] !== ref || $[24] !== t6) {
    t7 = <div className={styles.checkboxWrapper}><Checkbox {...props} ref={ref} id="subscribeToPlatformNewsletter">{t6}</Checkbox></div>;
    $[22] = props;
    $[23] = ref;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
});
function PlatformNewsletterCheckbox() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DonationFormField name="newsletter" as={NewsletterCheckbox} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default PlatformNewsletterCheckbox;